import './modal-question.scss';

//library
import { useRef, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
//shared
import Message from '../message/message';
import { MESSAGE_SUCCESS, MESSAGE_ERROR } from './constants/constants';
import Modal from '../modal-alert/modal-alert';
import { BRANCH_BY_ID, SAVE_RESPONSE_BRANCH } from '../../graphql/branch';
//material
import { Button, ToggleButton, ToggleButtonGroup } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

function GetBranch(branchId: number) {
    const { data, error } = useQuery(BRANCH_BY_ID, {
        variables: { branchId: branchId },
    });

    if (data) return data.branch.name;

    if (error) console.log(`Submission error! ${error.message}`);
}

const SetCheckBranchNaturalPerson = ({ idBranch, response, responseSuccess }: { idBranch: number, response: boolean, responseSuccess: (success:boolean) => void }) => {
    const [saveResponseBranch, { data, loading, error, reset }] = useMutation(SAVE_RESPONSE_BRANCH);

    if (data && data.saveReponseBranch) {
        responseSuccess(data.saveReponseBranch);
    };
    if (loading) return <CircularProgress size={25} />;
    if (error) console.log(`Submission error! ${error.message}`);

    return (
        <Button disabled={response == null} onClick={() => {
            saveResponseBranch({
                variables: {
                    branchId: idBranch,
                    answer: response,
                },
            })
            reset();
        }}>
            Guardar
        </Button>
    );
}

function ModalQuestion({ branchId }: { branchId: number }) {
    const [statusModal, changeStateModal] = useState<boolean>(true);
    const [response, changeResponse] = useState<any>(null);

    let message = MESSAGE_SUCCESS;
    let messageError = MESSAGE_ERROR;
    message.open = useRef<any>(null);

    const toggleResponse = (event: React.MouseEvent<HTMLElement>, newResponse: boolean) => {
        changeResponse(newResponse);
    };

    const responseSuccess = (success: boolean) => {
        if(success){
            setTimeout(() => { 
                changeStateModal(false);
                message.open.current.show();
            }, 500);
        }else{
            messageError.open.current.show();
        }
    }

    return (
        <>
            <Modal
                estatus={statusModal}
                changeStatus={changeStateModal}
                showHeader={true}
                title='Tenemos una pregunta para ti'
            >
                <div className='content-modal-question'>
                    <h1>En la sede {GetBranch(branchId)}, ¿Contratas a más de dos personas para realizar tu labor?</h1>
                    <ToggleButtonGroup value={response} exclusive onChange={toggleResponse} className='toggle-buttons'>
                        <ToggleButton value={false} color="primary">
                            No
                        </ToggleButton>
                        <ToggleButton value={true} color="primary">
                            Si
                        </ToggleButton>
                    </ToggleButtonGroup>
                    <SetCheckBranchNaturalPerson idBranch={branchId} response={response} responseSuccess={(success: boolean) => responseSuccess(success) }></SetCheckBranchNaturalPerson>
                </div>
            </Modal>
            <Message data={message} ref={message.open} />
        </>
    );
};

export default ModalQuestion;